// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/webdesktop/stylesheets/tabPanel.scss';
import React, { useState } from 'react';
import { Stack } from '../Stack/Stack';
export const TabItem = (props) => {
    return props.children;
};
export const TabPanel = ({ children, mode = 'default', initialIndex = 0, activeIndex, headerClassName, onTabChange }) => {
    const [internalIndex, setInternalIndex] = useState(initialIndex);
    const isControlled = activeIndex !== undefined;
    const currentIndex = isControlled ? activeIndex : internalIndex;
    const tabs = React.Children.toArray(children);
    const handleTabClick = (index) => {
        if (!isControlled) {
            setInternalIndex(index);
        }
        onTabChange === null || onTabChange === void 0 ? void 0 : onTabChange(index);
    };
    const tabPanelHeaderClassNames = ['tab-panel-header', mode === 'stretch' ? 'stretch' : '', headerClassName];
    const tabPanelHeaderClassName = tabPanelHeaderClassNames.filter(Boolean).join(' ');
    return (React.createElement("div", { className: "tab-panel" },
        React.createElement(Stack, { className: tabPanelHeaderClassName, role: "tablist", direction: "row" }, tabs.map((tab, index) => (React.createElement("button", { key: tab.props.title, className: `tab-panel-header-tab ${index === currentIndex ? 'selected' : ''}`, role: "tab", "aria-selected": index === currentIndex, disabled: tab.props.disabled, onClick: () => handleTabClick(index) }, tab.props.title)))),
        React.createElement("div", { className: "tab-panel-content", role: "tabpanel" }, tabs[currentIndex])));
};
